import _ from 'lodash';
import { useState } from 'react';

export const useUniqueId = ({ prefix }: { prefix: string }): string => {
    const [id] = useState(_.uniqueId(prefix));
    return id;
};
